import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>URL not found!</h1>
            <h2>Error 404</h2>
        </div>
    );
};

export default NotFound;